export const TOGGLE_LOADING = 'company/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'company/TOGGLE_SUCCESS'
export const SET_COMPANY = 'company/SET_COMPANY'
export const SET_COMPANIES = 'company/SET_COMPANIES'
export const SET_INITIAL_COMPANY = 'company/SET_INITIAL_COMPANY'
export const SET_COMPANY_FIELDS = 'company/SET_COMPANY_FIELDS'
export const SET_CREATION_XML = 'company/SET_CREATION_XML'
export const RESET_CREATION_XML = 'company/RESET_CREATION_XML'
export const SET_ERROR = 'company/SET_ERROR'
